/**
 * Feature flags configuration
 * Set to true to enable, false to disable features
 */
export const FEATURE_FLAGS = {
  // Lead generation forms
  STANDARD_LEAD_FORM: false,
  TESTIMONIAL_LEAD_FORM: true,
  COMPACT_LEAD_FORM: false,
  COMPACT_TESTIMONIAL_LEAD_FORM: true,
  
  // Salary comparison tool
  SALARY_COMPARISON: true,
  
  // New homepage design
  NEW_HOMEPAGE: true,
  
  // Simple take-home calculator
  SIMPLE_TAKE_HOME_CALCULATOR: true,
  
  // Pay rise simulator
  PAY_RISE_SIMULATOR: false,

  // 2029 pension salary sacrifice NI changes
  PENSION_2029_MODE: true,

  // Future features can be added here
  // ADVANCED_CALCULATOR: false,
  // PENSION_OPTIMIZER: false,
};

/**
 * Helper function to check if a feature is enabled
 * @param {string} featureName - The feature flag name
 * @returns {boolean} - Whether the feature is enabled
 */
export const isFeatureEnabled = (featureName) => {
  return FEATURE_FLAGS[featureName] === true;
};